import React from "react";
import { Link } from "react-router-dom";

const BUY_STEPS = [
  "Find your frames.",
  "Check the Condition Rating.",
  "Try them on virtually.",
  "Choose frames only or add clear lenses.",
  "Checkout.",
  "Look good for less.",
];

const SELL_STEPS = [
  "Tell us what you've got.",
  "Upload some photos.",
  "Receive an offer.",
  "Accept cash or choose higher-value trade-in credit where offered.",
  "Send us your glasses using the supplied shipping label.",
  "We inspect them.",
  "Get paid or receive your Lookers credit.",
];

function StepList({ steps, testId }) {
  return (
    <ol className="space-y-4" data-testid={testId}>
      {steps.map((s, i) => (
        <li key={i} className="flex gap-4">
          <span className="font-serif text-xl w-8 shrink-0 text-teal-600">{i + 1}</span>
          <span className="text-sm pt-1 text-zinc-800">{s}</span>
        </li>
      ))}
    </ol>
  );
}

export default function HowItWorks() {
  return (
    <div className="container-lookers py-16 max-w-2xl" data-testid="how-it-works-page">
      <section className="mb-16">
        <h1 className="font-serif text-4xl mb-8 text-zinc-900">
          Buying From Lookers
        </h1>
        <StepList steps={BUY_STEPS} testId="buying-steps" />
        <Link to="/shop" className="inline-block mt-8 bg-teal-600 hover:bg-teal-700 text-ink px-6 py-3 text-xs font-heading font-semibold uppercase tracking-wide rounded-full transition-colors">Shop Frames</Link>
      </section>
      <section>
        <h1 className="font-serif text-4xl mb-8 text-zinc-900">
          Selling To Lookers
        </h1>
        <StepList steps={SELL_STEPS} testId="selling-steps" />
        <Link to="/sell" className="inline-block mt-8 border border-zinc-200 hover:border-teal-600 hover:text-teal-700 text-zinc-800 px-6 py-3 text-xs font-heading font-semibold uppercase tracking-wide rounded-full transition-colors">Sell Your Frames</Link>
      </section>
    </div>
  );
}
